// Signed cover links stay in component memory; only normalized imported private image keys are admitted.
export function coverSource(path, baseUrl) {
  if (typeof path !== 'string' || !path.trim()) return { kind: 'empty' };
  if (path.startsWith('image/')) {
    const parts = path.split('/');
    if (!/^[1-9][0-9]*$/.test(parts[1] || '') || parts.length < 3 ||
      parts.some(part => !part || part === '.' || part === '..') || /[\\%?#]/.test(path) ||
      Array.from(path).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) {
      return { kind: 'invalid' };
    }
    return { kind: 'private', key: path };
  }
  return { kind: 'public', url: /^https?:\/\//.test(path) ? path : `${baseUrl}/${path}` };
}

export function privateCoverUrl(response, key, baseUrl) {
  if (coverSource(key, baseUrl).kind !== 'private') throw new Error('Cover unavailable');
  const images = response?.success === true && response?.data?.images;
  if (!Array.isArray(images) || images.length !== 1 || typeof images[0] !== 'string') throw new Error('Cover unavailable');
  let url;
  try { url = new URL(images[0]); } catch { throw new Error('Cover unavailable'); }
  let publicHost;
  try { publicHost = new URL(baseUrl).hostname; } catch { /* An absent public host admits only OSS API hosts. */ }
  const ossHost = /^[a-z0-9-]+\.oss-[a-z0-9-]+\.aliyuncs\.com$/i.test(url.hostname);
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.hash ||
    (!ossHost && url.hostname !== publicHost) || decodeURIComponent(url.pathname) !== `/${key}` ||
    !url.searchParams.get('Signature') || !url.searchParams.get('OSSAccessKeyId') ||
    !/^[1-9][0-9]*$/.test(url.searchParams.get('Expires') || '')) throw new Error('Cover unavailable');
  // HTTPS does not change the OSS object/signature and avoids mixed-content reads of private images.
  url.protocol = 'https:';
  return url.href;
}
